import InvelpsAuth from "./InvelpsAuth";

export default function LoginForm() {
  return <InvelpsAuth initialPage="login" />;
}
